
import { Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import hocFrom from '../../../components/forms/HocFrom';
import InputControl from '../../../components/inputs/InputControl';
import InputFarsi from '../../../components/inputs/InputFarsi';
import InputNumber from '../../../components/inputs/InputNumber';
import Switchrs from '../../../components/inputs/Switchrs';
import Loader from '../../../components/layout/Loader';

const FormPartnerCompany = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {

    const handelValue = (name, value) => {
        switch (name) {
            case 'name':
                handelsetdataForm({ ...formdata, name: value })
                break;
            case 'tel':
                handelsetdataForm({ ...formdata, tel: value })
                break;
            case 'avandBusinessId':
                handelsetdataForm({ ...formdata, avandBusinessId: value })
                break;
            case 'address':
                handelsetdataForm({ ...formdata, address: value })
                break;
            case 'serviceType':
                handelsetdataForm({ ...formdata, serviceType: parseInt(value) })
                break;
            case 'responsibleName':
                handelsetdataForm({ ...formdata, responsibleName: value })
                break;
            case 'responsibleTel':
                handelsetdataForm({ ...formdata, responsibleTel: value })
                break;
            case 'responsibleCellPhone':
                handelsetdataForm({ ...formdata, responsibleCellPhone: value })
                break;
            case 'isActiveFormPartnerCompany':
                handelsetdataForm({ ...formdata, isActive: value })
                break;
            default:
                break;
        }
    }

    const handelSubmit = event => {
        event.preventDefault()
        handelLoadingform(true)
        if (!formdata.name) {
            toast.error('وارد کردن نام شرکت اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.tel) {
            toast.error('وارد کردن تلفن شرکت اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.avandBusinessId) {
            toast.error('وارد کردن کد تجاری شرکت اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.address) {
            toast.error('وارد کردن آدرس شرکت اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.serviceType.length < 0) {
            toast.error('وارد کردن نوع شرکت همکار اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.responsibleName) {
            toast.error('وارد کردن نام سرپرست اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.responsibleTel) {
            toast.error('وارد کردن شماره تلفن ثابت سرپرست اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (!formdata.responsibleCellPhone) {
            toast.error('وارد کردن شماره موبایل سرپرست اجباری است', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.name ? handelUpdataFrom() : handelSend()
        }
    }

    return (
        <>
            {
                loding ? <Loader />

                    : <Form>
                        <Form.Row>
                            <Col>
                                <InputFarsi name='name' label='نام شرکت' handelValue={handelValue} defaultValue={dataUpdate.name} />
                            </Col>
                            <Col>
                                <InputNumber name='tel' label='تلفن شرکت' handelValue={handelValue} defaultValue={dataUpdate.tel} />
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>کد تجاری شرکت</Form.Label>
                                    <Form.Control type='text' name='avandBusinessId' defaultValue={dataUpdate ? dataUpdate.avandBusinessId : null} onChange={(e) => handelValue('avandBusinessId', e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <div className="form-group">
                                    <label for="replayTextarea">آدرس شرکت</label>
                                    <textarea className="form-control" id="replayTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.address : ''} onChange={(e) => handelValue('address', e.target.value)} ></textarea>
                                </div>
                            </Col>
                            <Col>
                                <InputControl url='/partnercompany/servicetypedropdown' name='serviceType' label='نوع شرکت همکار' handelValue={handelValue} defaultValue={dataUpdate.serviceType} />
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <InputFarsi name='responsibleName' label='نام سرپرست' handelValue={handelValue} defaultValue={dataUpdate.responsibleName} />
                            </Col>
                            <Col>
                                <InputNumber name='responsibleTel' label='شماره تلفن ثابت سرپرست' handelValue={handelValue} defaultValue={dataUpdate.responsibleTel} />
                            </Col>
                            <Col>
                                <InputNumber name='responsibleCellPhone' label='شماره موبایل سرپرست' handelValue={handelValue} defaultValue={dataUpdate.responsibleCellPhone} />
                            </Col>
                            <Switchrs label='آیا فعال باشد؟' name='isActiveFormPartnerCompany' handelValue={handelValue} checke={formdata.isActive} />
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <button type='submit' className='btn btn-success' onClick={handelSubmit} disabled={LoadingForm} >
                                    {LoadingForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : dataUpdate.name ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }
        </>
    );
}

export default hocFrom(FormPartnerCompany);
